import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import PartBOMService from "../../Controller/PartBOMController";
import PartService from "../../Controller/PartController";
import CreatePartBom from "./CreatePartBom";
import UpdateStockLocationBOM from "./UpdateStockLocationBOM";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
import LocationService from "../../../Setup/controller/LocationController/LocationController";
function PartListPage({ StockID, Tab }) {
    const navigate = useNavigate();
    const location = useLocation();
    const PartID = StockID;
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    const RoleID = localStorage.getItem('RoleID');
    const HelpLink = localStorage.getItem('HelpLink');
    const pathname = "/part/part-bom";
    const tableRef = useRef();
    const FormAction = "/PartList";
    // FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const [currentPartsbom, setCurrentPartbom] = useState(null);
    const [modalInstance, setModalInstance] = useState(null);
    const [modalStockLocation, setModalStockLocation] = useState(null);  // Updated state
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [partBOMList, setPartBomData] = useState([]);
    const [partList, setPartData] = useState([]);
    const [stockSelectedID, setStockSelectedID] = useState(null);  // New state for StockLocationID
    const [bomID, setBomID] = useState(null);  // New state for BOM ID
    const [StockLocationList, setStockLocation] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenSL, setIsModalOpenSL] = useState(false);
    const [loading, setLoading] = useState(true);
    const [LocationList, setLocationData] = useState([]);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    useEffect(() => {
        if (partBOMList.length > 0) {
            initDataTable();
        }
    }, [partBOMList]);
    const fetchPartsBOMS = async () => {
        try {
            $(tableRef.current).DataTable().destroy();
            setLoading(true);
            const data = await PartBOMService.GetAllStockBoms(redirectCallback, PartID);
            setPartBomData(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };

    const fetchParts = async () => {
        try {
            const data = await PartService.GetAllParts(redirectCallback);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchStockLocations = async (StockID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listOfLocations = await PartService.GetPartLocation(redirectCallback, StockID);
            setStockLocation(listOfLocations);
            return listOfLocations; // Return the list of locations
        } catch (error) {
            console.error('Error fetching locations:', error);
            return []; // Return an empty array in case of an error
        }
    };

    useEffect(() => {
        fetchPartsBOMS();
        fetchParts();
        fetchLocations();
        fetchStockLocations(StockID);
    }, [PartID, Tab]);

    const fetchLocations = async () => {
        try {
            const listOfLocations = await LocationService.GetAllLocations();
            setLocationData(listOfLocations);
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };


    const handleCreatePartBOMClick = async () => {
        setCurrentPartbom(null);
        fetchParts();

        let listOfLocations = await fetchStockLocations(StockID);

        listOfLocations = listOfLocations.filter(x => x.dec_Quantity > 0);
        debugger;

        const sizeOfList = listOfLocations.length;
        if (sizeOfList > 0) {
            Swal.fire(
                'Error!',
                'You cannot modify the BOM for this part when there are physical items in the stock.',
                'error'
            );
            return false;
        }
        else {
            setIsModalOpen(true);
        }
    };

    const handleEditClick = (part) => {
        setCurrentPartbom(part);
        fetchParts();
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {  // Updated function to accept a modal instance
        setIsModalOpen(false);
        setIsModalOpenSL(false);

    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await PartBOMService.DeleteStockBom(redirectCallback, ID);
                    $(tableRef.current).DataTable().destroy();
                    fetchPartsBOMS();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };


    const handleButtonClick = (PK_BOM_ID, FK_Stock_ID) => {

        setCurrentPartbom(null);
        setStockSelectedID(FK_Stock_ID);
        setBomID(PK_BOM_ID);
        setIsModalOpenSL(true);
    };
    const handleSuccess = () => {
        fetchPartsBOMS(); // Refresh the list after submission

        handleCloseModal();   // Close the modal
    };
    const handleSuccessSL = () => {
        fetchPartsBOMS();
        handleCloseModal();
    }

    //
    const [showSaveButton, setShowSaveButton] = useState(Array(partBOMList.length).fill(false));

    const handleQuantityChange = (event, index) => {
        const newQuantity = event.target.value;
        setPartBomData(prevState => {
            const updatedData = [...prevState];
            updatedData[index].Quantity = newQuantity;
            return updatedData;
        });

        // Show save button for this row when quantity is changed
        setShowSaveButton(prevState => {
            const updatedVisibility = [...prevState];
            updatedVisibility[index] = true;
            return updatedVisibility;
        });
    };


    const handleSaveQuantity = async (PK_BOM_ID, updatedQuantity, index) => {
        try {

            const intQuantity = parseInt(updatedQuantity.match(/\d+/), 10);

            if (isNaN(intQuantity) || intQuantity < 0) {
                Swal.fire("Error!", "Please enter a valid quantity!", "error");
                return;
            }


            await PartBOMService.UpdateQuantity(PK_BOM_ID, intQuantity);
            Swal.fire("Success!", "Quantity updated successfully!", "success");
            fetchPartsBOMS(); // Refresh data

            // Hide save button after saving
            setShowSaveButton(prevState => {
                const updatedVisibility = [...prevState];
                updatedVisibility[index] = false;
                return updatedVisibility;
            });
        } catch (error) {
            console.error('Error updating quantity:', error);
            Swal.fire("Error!", "Failed to update quantity!", "error");
        }
    };

    const [trialBuildQty, setTrialBuildQty] = useState(0);
    const [buildProductQty, setBuildProductQty] = useState(0);
    const [txtLocation, settxtLocation] = useState("");
    const [stockLocationID, setStockLocationID] = useState(0);
    const handleTrialBuild = () => {
        if (partBOMList.length === 0) {
            setTrialBuildQty(0);  // No data, clear input
            return;
        }

        // Compute min(Quantity / In Stock) for all parts
        let minBuild = Math.min(...partBOMList.map(part => {
            const quantity = parseFloat(part.Quantity);
            const inStock = parseFloat(part.dec_Quantity);
            return inStock > 0 ? Math.floor(inStock / quantity) : 0;
        }));

        setTrialBuildQty(minBuild);  // Update state with result
    };
    const handleBuildProduct = async () => {
        const buildQty = parseFloat(buildProductQty);
        const trialQty = parseFloat(trialBuildQty);

        if (isNaN(buildQty) || buildQty <= 0) {
            Swal.fire("Error!", "Please enter a valid quantity to build!", "error");
            return;
        }

        if (isNaN(stockLocationID) || stockLocationID <= 0) {
            Swal.fire("Error!", "Please select depot!", "error");
            return;
        }

        if (trialQty === 0) {
            Swal.fire("Error!", "Please run the Trial Build first!", "error");
            return;
        }

        if (buildQty > trialQty) {
            Swal.fire("Warning!", "Entered quantity exceeds Trial Build quantity!", "warning");
        } else {

            const requestData = {
                buildQty: buildQty,
                StockID: StockID,
                StockLocationID: stockLocationID,
                txtLocation: txtLocation,
                partBOMList: partBOMList.map(part => ({
                    PK_BOM_ID: part.PK_BOM_ID,
                    vc_StockCode: part.vc_StockCode,
                    vc_Description: part.vc_Description,
                    Quantity: part.Quantity,
                    dec_Quantity: part.dec_Quantity,
                    FK_Stock_ID: part.FK_Stock_ID,
                    LocationID: part.PK_StockLocation_ID
                }))
            };

            // const postData="Data saved successfully";
            const postData = await PartBOMService.BuildBOM(requestData);
            if (postData === "Data saved successfully") {
                localStorage.getItem('HasRecordUpdated');
                fetchPartsBOMS();
                setTrialBuildQty(0);
                setBuildProductQty(0);
                setStockLocationID(0);
                Swal.fire("Success!", "Build process started!", "success");

            }
            // Call API or perform the build logic here
        }
    };
    useEffect(() => {
        setStockLocationID(0); // Reset dropdown on component mount or relevant action
    }, []);
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <Link
                        className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}
                        onClick={handleCreatePartBOMClick}
                        to={`${location.pathname}${location.search}`} // Keep query parameters
                    >
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </Link>
                </div>
                <div className="col-sm-9" style={{ textAlign: "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">


                    <table className="table m-0 table-hover" ref={tableRef} style={{ "width": "100%" }}>
                        <thead>
                            <tr>
                                <th style={{ "width": "10%" }} className="no-wrap">Product Code</th>
                                <th style={{ "width": "20%" }} className="no-wrap">Description</th>
                                <th style={{ "width": "10%" }} className="no-wrap">Build from Depot</th>
                                <th style={{ "width": "35%" }} className="no-wrap">Quantity</th>
                                <th style={{ "width": "10%" }} className="no-wrap">Type</th>
                                <th style={{ "width": "10%" }} className="no-wrap">In Stock</th>
                                <th style={{ "width": "5%", "textAlign": "right" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {partBOMList.map((part, index) => (
                                <tr key={part.PK_BOM_ID}>
                                    <td style={{ "width": "10%" }} className="no-wrap">{part.vc_StockCode}</td>
                                    <td style={{ "width": "20%" }} className="no-wrap">{part.vc_Description}</td>
                                    <td style={{ "width": "10%" }} className="no-wrap">

                                        <strong
                                            onClick={() => handleButtonClick(part.PK_BOM_ID, part.FK_Stock_ID)}
                                            style={{ cursor: 'pointer', color: 'green' }}
                                        >
                                            {part.vc_Name}
                                        </strong>
                                    </td>
                                    <td style={{ "width": "35%" }} className="no-wrap">
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="text"
                                                value={part.Quantity}
                                                onChange={(e) => handleQuantityChange(e, index)}
                                                className="form-control form-control-sm"

                                            />
                                            {showSaveButton[index] && (
                                                <button
                                                    className="btn btn-success btn-sm"
                                                    style={{ padding: "2px 6px", fontSize: "12px" }}
                                                    onClick={() => handleSaveQuantity(part.PK_BOM_ID, part.Quantity, index)}
                                                >
                                                    Save
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                    <td style={{ "width": "10%" }} className="no-wrap">{part.Type}</td>
                                    <td style={{ "width": "10%" }} className="no-wrap">{part.dec_Quantity}</td>
                                    <td className="rightColumn" style={{ "width": "10%", "textAlign": "right" }}>

                                        <button style={{ "background": "none", "border": "none" }} className="text-danger mr-2" onClick={(event) => handleDeleteClick(event, part.PK_BOM_ID)}>
                                            <i className="icofont-ui-delete" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            </div>
            <div className="container mt-5">
                <div className="row">
                    <div className='col-sm-2'>
                        <button type="button" className="btn btn-secondary" onClick={handleTrialBuild}>
                            Trial Build
                        </button>
                    </div>
                    <div className='col-sm-2'>
                        <input type="text" className="form-control" value={trialBuildQty} readOnly />
                    </div>
                    <div className='col-sm-2'>
                        <button type="button" className="btn btn-success" onClick={handleBuildProduct}>
                            Build Product
                        </button>
                    </div>
                    <div className='col-sm-2'>
                        <input type="text" className="form-control" value={buildProductQty} onChange={(e) => setBuildProductQty(e.target.value)} />
                    </div>
                    <div className='col-sm-2'>
                        <select name="LocationID" className='form-control' value={stockLocationID} onChange={(e) => setStockLocationID(e.target.value)}>
                            <option value="0">To Depots</option>
                            {LocationList.map((location) => (
                                <option key={location.PK_Location_ID} value={location.PK_Location_ID} >
                                    {location.vc_Name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='col-sm-2'>
                        <input type="text" className="form-control" value={txtLocation} onChange={(e) => settxtLocation(e.target.value)} />

                    </div>


                </div>
            </div>



            {isModalOpen && (
                <CreatePartBom PartID={PartID} part={currentPartsbom} onClose={() => handleCloseModal(handleCloseModal)} onSuccess={handleSuccess} partList={partList} />
            )}

            {isModalOpenSL && (
                <UpdateStockLocationBOM onClose={() => handleCloseModal(handleCloseModal)} onSuccess={handleSuccessSL} StockID={PartID} stockSelectedID={stockSelectedID} BOMID={bomID} />

            )}





        </div>
    );
}

export default PartListPage;
